/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Australian_EnglishInputs */



/**
* | output |
* | --- |
* | "Australian English" |
*
* @param {Australian_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const australian_english = /** @type {((inputs?: Australian_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Australian_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anglais australien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Australisches Englisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inglese australiano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("австралийский английский")
	if (locale === "es") return /** @type {LocalizedString} */ ("inglés australiano")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("澳大利亚英语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーストラリア英語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑस्ट्रेलियाई अंग्रेज़ी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inglês australiano")
	return /** @type {LocalizedString} */ ("Australian English")
});